import createElement from './createElement';
// Global helpers
import api from '../core/utils/api';
import rememberMeActionWrapper from '../visual-components/rememberMe-actions';
var replyCard = function (config, section, item, personId) {
    var wrapper = createElement('div');
    var onSubmit = function (data) {
        var payload = {
            message: data.message,
            name: data.name,
            email: data.email,
            private: !!data.private,
            type: 'condolence',
        };
        // Send the reply
        return api.post("/person/".concat(personId, "/interaction/").concat(item.id), payload, {
            'X-Widget-Id': config._id,
            'X-Widget-Instance-Id': config._widgetInstanceId,
            'X-Customer-Id': config._customerId,
            'X-Uri': window.location.href,
        });
    };
    var modalEl = rememberMeActionWrapper(config, section, onSubmit, true, item);
    wrapper.appendChild(modalEl);
    return wrapper;
};
export default replyCard;
